import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  categories: {
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
  units: {
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
  categorySources: {
    loading: false,
    error: null,
    data: [],
    category: null,
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
  sourceInputFields: {
    loading: false,
    error: null,
    data: [],
    source: null,
    staticConfigFields: {},
    units: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
  sourceInputData: {
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
  loadedCategorySource: {
    loading: false,
    data: null,
  },
  formLoading: false,
  formError: null,
  formSubmitSuccess: true,
};

export const corporateSlice = createSlice({
  name: 'calcEngine',
  initialState,
  reducers: {
    fetchUnitsRequest: (state) => {
      state.units.loading = true;
      state.units.error = null;
    },
    fetchUnitsSuccess: (state, {payload}) => {
      const {data, page, pageSize, totalPages, totalRecords, sortOn, sortDir} =
        payload;
      state.units.loading = false;
      state.units.data = data;
      state.units.page = page;
      state.units.pageSize = pageSize;
      state.units.totalPages = totalPages;
      state.units.totalCount = totalRecords;
      state.units.sortOn = sortOn;
      state.units.sortDir = sortDir;
    },
    fetchUnitsError: (state, {payload}) => {
      state.units.loading = false;
      state.units.error = payload;
    },
    fetchCategoriesRequest: (state) => {
      state.categories.loading = true;
      state.categories.error = null;
    },
    fetchCategoriesSuccess: (state, {payload}) => {
      const {data, page, pageSize, totalPages, totalRecords, sortOn, sortDir} =
        payload;
      state.categories.loading = false;
      state.categories.data = data;
      state.categories.page = page;
      state.categories.pageSize = pageSize;
      state.categories.totalPages = totalPages;
      state.categories.totalCount = totalRecords;
      state.categories.sortOn = sortOn;
      state.categories.sortDir = sortDir;
    },
    fetchCategoriesError: (state, {payload}) => {
      state.categories.loading = false;
      state.categories.error = payload;
    },
    fetchCategorySourcesRequest: (state) => {
      state.categorySources.loading = true;
      state.categorySources.error = null;
    },
    fetchCategorySourcesSuccess: (state, {payload}) => {
      const {
        data,
        category,
        page,
        pageSize,
        totalPages,
        totalRecords,
        sortOn,
        sortDir,
      } = payload;
      state.categorySources.loading = false;
      state.categorySources.data = data;
      state.categorySources.category = category;
      state.categorySources.page = page;
      state.categorySources.pageSize = pageSize;
      state.categorySources.totalPages = totalPages;
      state.categorySources.totalCount = totalRecords;
      state.categorySources.sortOn = sortOn;
      state.categorySources.sortDir = sortDir;
    },
    fetchCategorySourcesError: (state, {payload}) => {
      state.categorySources.loading = false;
      state.categorySources.error = payload;
    },
    createCategoryRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    createCategorySuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.formSubmitSuccess = true;
      if (state.categories.data.length) {
        state.categories.data.splice(0, 1, {...data}, state.categories.data[0]);
      } else {
        state.categories.data.push(data);
      }
    },
    createCategoryError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    updateCategoryRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    updateCategorySuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.formSubmitSuccess = true;
      const foundItemIndex = state.categories.data.findIndex(
        (item) => item.id === data.id
      );
      if (foundItemIndex >= 0) {
        state.categories.data[foundItemIndex] = data;
      }
    },
    updateCategoryError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    removeCategoryRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    removeCategorySuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.categories.data = state.categories.data.filter(
        (item) => item.id !== data.id
      );
    },
    removeCategoryError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    createCategorySourceRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    createCategorySourceSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.formSubmitSuccess = true;

      state.categorySources.data.push(data);
    },
    createCategorySourceError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    updateCategorySourceRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    updateCategorySourceSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.formSubmitSuccess = true;
      const foundItemIndex = state.categorySources.data.findIndex(
        (item) => item.id === data.id
      );
      if (foundItemIndex >= 0) {
        state.categorySources.data[foundItemIndex] = data;
      }
    },
    updateCategorySourceError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    removeCategorySourceRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    removeCategorySourceSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.categorySources.data = state.categorySources.data.filter(
        (item) => item.id !== data.id
      );
    },
    removeCategorySourceError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    createUnitRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    createUnitSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.formSubmitSuccess = true;
      state.units.data.push(data);
    },
    createUnitError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    updateUnitRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    updateUnitSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.formSubmitSuccess = true;
      const foundItemIndex = state.units.data.findIndex(
        (item) => item.id === data.id
      );
      if (foundItemIndex >= 0) {
        state.units.data[foundItemIndex] = data;
      }
    },
    updateUnitError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    removeUnitRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    removeUnitSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.units.data = state.units.data.filter((item) => item.id !== data.id);
    },
    removeUnitError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    fetchInputTableFieldsRequest: (state) => {
      state.units.loading = true;
      state.units.error = null;
    },
    fetchInputTableFieldsSuccess: (state, {payload}) => {
      const {
        data,
        source,
        staticConfigFields,
        units,
        page,
        pageSize,
        totalPages,
        totalRecords,
        sortOn,
        sortDir,
      } = payload;
      state.sourceInputFields.loading = false;
      state.sourceInputFields.data = data;
      state.sourceInputFields.source = source;
      state.sourceInputFields.staticConfigFields = staticConfigFields;
      state.sourceInputFields.units = units;
      state.sourceInputFields.page = page;
      state.sourceInputFields.pageSize = pageSize;
      state.sourceInputFields.totalPages = totalPages;
      state.sourceInputFields.totalCount = totalRecords;
      state.sourceInputFields.sortOn = sortOn;
      state.sourceInputFields.sortDir = sortDir;
    },
    fetchInputTableFieldsError: (state, {payload}) => {
      state.sourceInputFields.loading = false;
      state.sourceInputFields.error = payload;
    },
    createInputTableFieldRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    createInputTableFieldSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.formSubmitSuccess = true;
      // if (state.sourceInputFields.data.length) {
      //   state.sourceInputFields.data.splice(
      //     0,
      //     1,
      //     {...data},
      //     state.sourceInputFields.data[0]
      //   );
      // } else {
      state.sourceInputFields.data.push(data);
      // }
    },
    createInputTableFieldError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    updateInputTableFieldRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    updateInputTableFieldSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.formSubmitSuccess = true;
      const foundItemIndex = state.sourceInputFields.data.findIndex(
        (item) => item.id === data.id
      );
      if (foundItemIndex >= 0) {
        state.sourceInputFields.data[foundItemIndex] = data;
      }
    },
    updateInputTableFieldError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    removeInputTableFieldRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    removeInputTableFieldSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.sourceInputFields.data = state.sourceInputFields.data.filter(
        (item) => item.id !== data.id
      );
    },
    removeInputTableFieldError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    fetchInputTableDataRequest: (state) => {
      state.units.loading = true;
      state.units.error = null;
    },
    fetchInputTableDataSuccess: (state, {payload}) => {
      const {data, page, pageSize, totalPages, totalRecords, sortOn, sortDir} =
        payload;
      state.sourceInputData.loading = false;
      state.sourceInputData.data = data;
      state.sourceInputData.page = page;
      state.sourceInputData.pageSize = pageSize;
      state.sourceInputData.totalPages = totalPages;
      state.sourceInputData.totalCount = totalRecords;
      state.sourceInputData.sortOn = sortOn;
      state.sourceInputData.sortDir = sortDir;
    },
    fetchInputTableDataError: (state, {payload}) => {
      state.sourceInputData.loading = false;
      state.sourceInputData.error = payload;
    },
    createInputTableDataRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    createInputTableDataSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.formSubmitSuccess = true;
      // if (state.sourceInputData.data.length) {
      //   state.sourceInputData.data.splice(
      //     0,
      //     1,
      //     {...data, data: JSON.parse(data.data)},
      //     state.sourceInputData.data[0]
      //   );
      // } else {
      state.sourceInputData.data.push({...data, data: JSON.parse(data.data)});
      // }
    },
    createInputTableDataError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    updateInputTableDataRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    updateInputTableDataSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.formSubmitSuccess = true;
      const foundItemIndex = state.sourceInputData.data.findIndex(
        (item) => item.id === data.id
      );
      if (foundItemIndex >= 0) {
        state.sourceInputData.data[foundItemIndex] = {
          ...data,
          data: JSON.parse(data.data),
        };
      }
    },
    updateInputTableDataError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    removeInputTableDataRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    removeInputTableDataSuccess: (state, {payload}) => {
      const {data} = payload;
      state.formLoading = false;
      state.sourceInputData.data = state.sourceInputData.data.filter(
        (item) => item.id !== data.id
      );
    },
    removeInputTableDataError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    resetFormSubmitSuccess: (state, {payload}) => {
      state.formSubmitSuccess = payload;
    },
    resetFormError: (state, {payload}) => {
      state.formError = payload;
    },

    fetchCategorySourceRequest: (state) => {
      state.loadedCategorySource.loading = true;
      state.loadedCategorySource.error = null;
    },
    fetchCategorySourceSuccess: (state, {payload}) => {
      const {data} = payload;
      state.loadedCategorySource.loading = false;
      state.loadedCategorySource.data = data;
    },
    fetchCategorySourceError: (state, {payload}) => {
      state.loadedCategorySource.loading = false;
      state.loadedCategorySource.error = payload;
    },
  },
});

export const {
  fetchUnitsRequest,
  fetchUnitsSuccess,
  fetchUnitsError,
  fetchCategoriesRequest,
  fetchCategoriesSuccess,
  fetchCategoriesError,
  fetchCategorySourcesRequest,
  fetchCategorySourcesSuccess,
  fetchCategorySourcesError,
  createCategoryRequest,
  createCategorySuccess,
  createCategoryError,
  updateCategoryRequest,
  updateCategorySuccess,
  updateCategoryError,
  removeCategoryRequest,
  removeCategorySuccess,
  removeCategoryError,
  createCategorySourceRequest,
  createCategorySourceSuccess,
  createCategorySourceError,
  updateCategorySourceRequest,
  updateCategorySourceSuccess,
  updateCategorySourceError,
  removeCategorySourceRequest,
  removeCategorySourceSuccess,
  removeCategorySourceError,
  createUnitRequest,
  createUnitSuccess,
  createUnitError,
  updateUnitRequest,
  updateUnitSuccess,
  updateUnitError,
  removeUnitRequest,
  removeUnitSuccess,
  removeUnitError,
  fetchInputTableFieldsRequest,
  fetchInputTableFieldsSuccess,
  fetchInputTableFieldsError,
  createInputTableFieldRequest,
  createInputTableFieldSuccess,
  createInputTableFieldError,
  updateInputTableFieldRequest,
  updateInputTableFieldSuccess,
  updateInputTableFieldError,
  removeInputTableFieldRequest,
  removeInputTableFieldSuccess,
  removeInputTableFieldError,
  fetchInputTableDataRequest,
  fetchInputTableDataSuccess,
  fetchInputTableDataError,
  createInputTableDataRequest,
  createInputTableDataSuccess,
  createInputTableDataError,
  updateInputTableDataRequest,
  updateInputTableDataSuccess,
  updateInputTableDataError,
  removeInputTableDataRequest,
  removeInputTableDataSuccess,
  removeInputTableDataError,
  resetFormSubmitSuccess,
  resetFormError,
  fetchCategorySourceRequest,
  fetchCategorySourceSuccess,
  fetchCategorySourceError,
} = corporateSlice.actions;

export default corporateSlice.reducer;
